import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';

export default function EmptyState({ message, subMessage }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50/50 px-6 py-12 text-center">
      <FiBarChart2 className="mb-3 h-12 w-12 text-slate-300" />
      <p className="text-sm font-medium text-slate-600">{message}</p>
      {subMessage && <p className="mt-1 text-xs text-slate-500">{subMessage}</p>}
    </div>
  );
}
